import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const ChecklistItem = styled.div`
  padding: 8px 0;
  display: flex;

  &:first-child {
    padding-top: 26px;
  }

  &:last-child {
    padding-bottom: 26px;
  }
`;

export const Icon = styled.span`
  display: none;
  padding-right: 24px;

  @media ${breakpoints.large} {
    display: inline-block;
  }
`;

export const Label = styled.div`
  margin: auto;

  @media ${breakpoints.large} {
    margin: 0;
  }
`;
